import * as english from "./english.js";

// Decide which language the static text should be shown in.
export const getLanguage = (props) => {
    return english;
};
